import Vue from 'vue';

import App from "../app.vue";
import VueDragResize from "vue-drag-resize";
import store from "./store";

Vue.config.productionTip = false;
Vue.component("VueDragResize", VueDragResize);

Vue.mixin({
  methods: {
    l: function(key) {
      var paths = key.split(".");
      var result = window.label;
      paths.forEach(function(key) {
        result = result && result[key]
      })
      // for (let i of paths) {
      //   result = result && result[i];
      // }
      return result;
    }
  }
});

function init() {
  new Vue({
    store,
    render: h => h(App)
  }).$mount("#app");
}

document.addEventListener("DOMContentLoaded", function() {
  var defaultLanguage = window.locale;
  var xhr = new XMLHttpRequest();
  xhr.onload = function() {
    window.label = JSON.parse(xhr.response);
    init();
  };
  xhr.open("GET", `/page/qrcode_generator_language/${defaultLanguage}`);
  xhr.send();
})
